import { useSelector } from 'react-redux';
import { oneErrorOnNotOkFetchye, replaceDomainForCacheKey, useErrorOnNotOkFetchye } from '@americanexpress/fetchye-amex';
import { getFullOneCMSUrl } from '../selectors/moduleStateSelectors';
import { getIsLocalhost } from '../selectors/getIsLocalhostSelector';

const fetchyeOpts = {
  mapKeyToCacheKey: replaceDomainForCacheKey('oneCMS'),
  credentials: 'include',
};

export const travelCreditOneCMSReporting = ({ key, error }) => ({
  moduleID: 'axp-travel-credit',
  component: 'travelCreditOneCMSFetchye',
  fetch: {
    url: key,
    status: error?.status,
  },
});

export const useTravelCreditOneCMS = () => {
  const url = useSelector(getFullOneCMSUrl);
  const isLocalhost = useSelector(getIsLocalhost);
  if (!isLocalhost) delete fetchyeOpts.credentials;
  return useErrorOnNotOkFetchye(url, {
    ...fetchyeOpts,
  }, travelCreditOneCMSReporting);
};

export const loadTravelCreditOneCMS = async (dispatch, getState) => {
  const state = getState();
  const url = getFullOneCMSUrl(state);
  if (!getIsLocalhost(state)) delete fetchyeOpts.credentials;
  return dispatch(oneErrorOnNotOkFetchye(url, {
    ...fetchyeOpts,
  }, travelCreditOneCMSReporting));
};
